export enum MissionFormTab {
  Address = 'address',
  CodingConfig = 'codingConfig',
  Collaboration = 'collaboration',
  ExternalActors = 'externalActors',
  GeneralInfo = 'generalInfo',
  InternalActors = 'internalActors',
  SubMissionActors = 'subMissionActors',
  Type = 'type',
}
